import type { TOC } from '@ember/component/template-only';
import { notEq } from 'ember-truth-helpers';
import { IncrementFor } from 'frontend-utils';
import SettingsPmsIntegrationRoomtypeHierarchyTreeNode from 'lumen/components/settings/pms-integration/roomtype-hierarchy-tree-node';
import add from 'lumen/helpers/add';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function hasChildren(node: unknown) {
  // @ts-expect-error: Incorrect type
  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  return Object.keys(node.children).length > 0;
}

interface SettingsPmsIntegrationRoomtypeHierarchyTreeVisualisationSignature {
  Args: {
    channelId: unknown;
    channelRoomNameToColorMapping: unknown;
    level: unknown;
    localSettingsCopy: unknown;
    node: unknown;
    pmsPrefillOptions: unknown;
  };
}

const SettingsPmsIntegrationRoomtypeHierarchyTreeVisualisation = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <ul>
    {{#each-in @node as |name node|}}
      {{! Only show the node in the visualisation if it is checked in the panel settings }}
      {{#if node.included}}
        <li class="{{if (notEq @level 0) 'child-node'}} flex flex-row">
          <div class={{if (notEq @level 0) "child-node__connector"}}></div>
          <IncrementFor @times={{@level}}>
            <span class="child-node__indenter"></span>
          </IncrementFor>
          <div class="roomtype-hierarchy-node-container">
            <SettingsPmsIntegrationRoomtypeHierarchyTreeNode
              @channelId={{@channelId}}
              @channelRoomNameToColorMapping={{@channelRoomNameToColorMapping}}
              @localSettingsCopy={{@localSettingsCopy}}
              @name={{name}}
              @node={{node}}
              @pmsPrefillOptions={{@pmsPrefillOptions}}
            />
          </div>
        </li>
      {{/if}}

      {{#if (hasChildren node)}}
        <SettingsPmsIntegrationRoomtypeHierarchyTreeVisualisation
          @channelId={{@channelId}}
          @channelRoomNameToColorMapping={{@channelRoomNameToColorMapping}}
          @level={{add @level 1}}
          @localSettingsCopy={{@localSettingsCopy}}
          @node={{node.children}}
          @pmsPrefillOptions={{@pmsPrefillOptions}}
        />
      {{/if}}
    {{/each-in}}
  </ul>
</template> satisfies TOC<SettingsPmsIntegrationRoomtypeHierarchyTreeVisualisationSignature>;

export default SettingsPmsIntegrationRoomtypeHierarchyTreeVisualisation;
